import { setDynamicState } from 'Utils/dynamic-state';

function fetchAndAppendToBody(url, dynamicState) {
    $.get({ url })
        .then((data) => {
            if (data) {
                $('body').append(data);
                setDynamicState(dynamicState, true);
            } else {
                setDynamicState(dynamicState, false);
            }
        })
        .catch(() => {
            setDynamicState(dynamicState, false);
        });
}

export function handleModals() {
    if (window.__VUMEDI_CONTEXT__?.appGateActive === true) {
        setDynamicState('update-site-and-subscriptions-modal', false);
        setDynamicState('update-subspecialty-subscriptions-modal', false);
        return;
    }

    const { changeSiteURL, updateSubspecialtySubscriptionURL } = window.__VUMEDI_CONTEXT__ || {};

    if (changeSiteURL) {
        fetchAndAppendToBody(changeSiteURL, 'update-site-and-subscriptions-modal');
    }
    if (updateSubspecialtySubscriptionURL) {
        fetchAndAppendToBody(updateSubspecialtySubscriptionURL, 'update-subspecialty-subscriptions-modal');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    handleModals();
});
